<template>
    <v-card tile flat class="d-inline-flex align-center theme-background">
        <v-badge
            :icon="possibleStatuses[currentStatus].icon"
            :color="possibleStatuses[currentStatus].colour"
            overlap
        >
            <v-card tile flat class="display-1 d-flex justify-start theme-background theme-title" :title="possibleSaveMethods[currentSaveMethod].title">
                <img :src="possibleSaveMethods[currentSaveMethod][$vuetify.theme.dark ? 'iconDark' : 'iconLight']" alt=""/>
                <!-- <v-icon x-large class="theme-text">{{ possibleSaveMethods[currentSaveMethod].icon }}</v-icon> -->
            </v-card>
        </v-badge>

        <v-card tile flat class="ml-2 text-truncate transparent theme-text status-text">
            {{ possibleStatuses[currentStatus].text }}
        </v-card>
    </v-card>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: 'Connection',
        data: function () {
            return {
                currentStatus: 'ok',
                currentSaveMethod: 'auto',
                possibleStatuses: {
                    error: {
                        colour: 'error',
                        icon: 'mdi-exclamation',
                        text: 'Nincs kapcsolat!'
                    },
                    sync: {
                        colour: 'warning',
                        icon: 'mdi-sync',
                        spinning: true,
                        text: 'Szinkronizáció...'
                    },
                    ok: {
                        colour: 'success',
                        icon: 'mdi-check',
                        text: 'Szinkronizálva'
                    },
                },
                possibleSaveMethods: {
                    auto: {
                        iconLight: '/icons/A_light.svg',
                        iconDark: '/icons/A_dark.svg',
                        title: 'Automatikus'
                    },
                    manual: {
                        iconLight: '/icons/M_light.svg',
                        iconDark: '/icons/M_dark.svg',
                        title: 'Manuális'
                    }
                },
            };
        },
        created() {
            let self = this;
            this.$busOn(CONSTANTS.EVENTS.CHANGE.CONNECTION, function(value) {
                if(value === "okfromsync"){
                    value = "ok";
                }
                self.currentStatus = value;
            });
            this.$busOn(CONSTANTS.EVENTS.CHANGE.CONNECTIONSAVEMETHOD, function(value) {
                self.currentSaveMethod = value
            });
        }
    }
</script>

<style>
    .status-text {
        font-size: 10px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
    }
</style>
